/**
 * ResponsavelConfigEmail
 * @author gabrielbgil
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import StatusSms from '@/model/resource/StatusSms'
import ResponsavelConfigEmailSchema from '@/schema/ResponsavelConfigEmail.schema'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'

export default class ResponsavelConfigEmail extends Resource {
  readonly $name: string = 'ResponsavelConfigEmail'

  readonly $endpoint: string = '/user/config-email/configuracao{/id}'

  get $schema() {
    return ResponsavelConfigEmailSchema(this)
  }

  get $id() {
    return this.idConfigEmailPk
  }
  set $id(val: ID) {
    this.idConfigEmailPk = val
  }

  get isOcorrenciaSelected() {
    return this.statusEmail && this.statusEmail.idStatusPk === StatusSms.OCORRENCIA
  }

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(StatusSms)
  statusEmail: StatusSms | null = null

  @ResponseSerialize(TipoOcorrencia)
  ocorrencia: TipoOcorrencia | null = null

  idConfigEmailPk: ID = 0

  idConfigEmailRegraEnvioFk: number = 1

  @ValidationRequired()
  @ValidationMaxLength(2000)
  mensagem: string = ''

  @ValidationRequired()
  ativo: boolean = true

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  idStatusFk: ID = 0

  async persistResponsavelConfigEmail(model?: ResponsavelConfigEmail, spinner = 'persistResponsavelConfigEmail') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/config-email/configuracao`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getResponsavelConfigEmail(id: number, spinner = 'getResponsavelConfigEmail') {
    const fetch = async () => await this.GET(`/user/config-email/configuracao/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
